"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationErrorToUserFriendlyMessage = exports.runAllValidators = exports.VALIDATORS = exports.reachedMinimumOptionRequirements = exports.getInitiallySelectedOptionItems = exports.validateBasketItems = exports.validateBasketItemUpdate = exports.validateBasketItemsDelete = exports.isBasketItemStillActive = exports.getMinDateAllowed = exports.calculateOptions = exports.timePopoverFormat = exports.addDurationToDateConsideringSomeDays = exports.basketLocationToAddress = void 0;
var addresses_1 = require("./helpers/addresses");
Object.defineProperty(exports, "basketLocationToAddress", { enumerable: true, get: function () { return addresses_1.basketLocationToAddress; } });
var date_1 = require("./helpers/date");
Object.defineProperty(exports, "addDurationToDateConsideringSomeDays", { enumerable: true, get: function () { return date_1.addDurationToDateConsideringSomeDays; } });
var time_1 = require("./helpers/time");
Object.defineProperty(exports, "timePopoverFormat", { enumerable: true, get: function () { return time_1.timePopoverFormat; } });
Object.defineProperty(exports, "calculateOptions", { enumerable: true, get: function () { return time_1.calculateOptions; } });
Object.defineProperty(exports, "getMinDateAllowed", { enumerable: true, get: function () { return time_1.getMinDateAllowed; } });
var basketItems_1 = require("./validators/basketItems");
Object.defineProperty(exports, "isBasketItemStillActive", { enumerable: true, get: function () { return basketItems_1.isBasketItemStillActive; } });
Object.defineProperty(exports, "validateBasketItemsDelete", { enumerable: true, get: function () { return basketItems_1.validateBasketItemsDelete; } });
Object.defineProperty(exports, "validateBasketItemUpdate", { enumerable: true, get: function () { return basketItems_1.validateBasketItemUpdate; } });
Object.defineProperty(exports, "validateBasketItems", { enumerable: true, get: function () { return basketItems_1.validateBasketItems; } });
Object.defineProperty(exports, "getInitiallySelectedOptionItems", { enumerable: true, get: function () { return basketItems_1.getInitiallySelectedOptionItems; } });
Object.defineProperty(exports, "reachedMinimumOptionRequirements", { enumerable: true, get: function () { return basketItems_1.reachedMinimumOptionRequirements; } });
const ts_pattern_1 = require("ts-pattern");
const addresses_2 = require("./validators/addresses");
const date_2 = require("./validators/date");
const headCount_1 = require("./validators/headCount");
const time_2 = require("./validators/time");
const types_shared_1 = require("./types.shared");
const basketItems_2 = require("./validators/basketItems");
const billingAddress_1 = require("./validators/billingAddress");
exports.VALIDATORS = {
    address: addresses_2.validateAddress,
    date: date_2.validateDate,
    time: time_2.validateTime,
    headCount: headCount_1.validateHeadCount,
    basketItems: basketItems_2.validateBasketItems,
    billingAddress: billingAddress_1.validateBillingAddress,
};
const codesWithAdminApprovalOverride = [
    'VENDER_COVERAGE',
    'NO_LATITUDE_OR_LONGITUDE',
    'INVALID_TIME',
    'DATE_CLOSED',
    'CLOSED_LARGE_ORDER',
    'INVALID_HEAD_COUNT',
    'PAST_THRESHOLD',
    'TOO_LOW',
    'TOO_HIGH',
];
const runAllValidators = ({ userState, inRangeLocations, basketIsFeedrAdminApproved, useDeliveryTimes, deliveryTimeRange }) => {
    const addressResponse = exports.VALIDATORS.address({
        userState,
        inRangeLocations,
    });
    if (!addressResponse.newLocations.length && !basketIsFeedrAdminApproved)
        return { address: addressResponse };
    let dateResponse = exports.VALIDATORS.date({
        userState,
        filteredLocations: addressResponse.newLocations,
    });
    let timeResponse = exports.VALIDATORS.time({
        userState,
        filteredLocations: dateResponse.newLocations,
        useDeliveryTimes,
        deliveryTimeRange,
    });
    if (timeResponse.result.type === 'error' && dateResponse.result.type === 'error') {
        if (dateResponse.result.payload.code === 'DATE_PAST') {
            timeResponse = {
                result: (0, types_shared_1.ok)(),
                newLocations: dateResponse.newLocations,
            };
        }
        if (timeResponse.result.type === 'error' &&
            dateResponse.result.payload.code !== 'DATE_PAST' &&
            timeResponse.result.payload.code === 'TIME_PAST') {
            dateResponse = {
                result: (0, types_shared_1.ok)(),
                newLocations: timeResponse.newLocations,
            };
        }
    }
    const headCountResponse = exports.VALIDATORS.headCount({
        dateError: dateResponse.result.type === 'error' ? dateResponse.result.payload.code : '',
        userState,
        filteredLocations: timeResponse.newLocations,
    });
    const applyAdminApprovalOverride = (response) => {
        if (!basketIsFeedrAdminApproved || response.result.type === 'success')
            return response;
        return codesWithAdminApprovalOverride.includes(response.result.payload.code)
            ? { ...response, result: (0, types_shared_1.ok)() }
            : response;
    };
    return {
        address: applyAdminApprovalOverride(addressResponse),
        date: applyAdminApprovalOverride(dateResponse),
        time: applyAdminApprovalOverride(timeResponse),
        headCount: applyAdminApprovalOverride(headCountResponse),
    };
};
exports.runAllValidators = runAllValidators;
const validationErrorToUserFriendlyMessage = (e) => (0, ts_pattern_1.match)(e)
    .with({ code: 'INVALID_ADDRESS_NO_DATE' }, () => undefined)
    .with({ code: 'INVALID_ADDRESS' }, () => 'Please enter a valid UK or Ireland address.')
    .with({ code: 'VENDER_COVERAGE' }, () => 'This vendor doesn’t serve this location.')
    .with({ code: 'NO_LATITUDE_OR_LONGITUDE' }, () => 'This vendor doesn’t serve this location.')
    .with({ code: 'NO_LOCATION' }, () => 'Please enter a street address.')
    .with({ code: 'NO_STREET_ADDRESS' }, () => 'Please enter a street address.')
    .with({ code: 'INVALID_DATE' }, () => 'Enter a valid date')
    .with({ code: 'NO_DATE' }, () => 'Enter a valid date')
    .with({ code: 'DATE_CLOSED' }, () => 'Vendor is closed')
    .with({ code: 'CLOSED_LARGE_ORDER' }, () => 'Vendor is closed')
    .with({ code: 'DATE_PAST' }, () => "This date isn't available anymore.")
    .with({ code: 'INVALID_TIME' }, () => 'Enter a valid time')
    .with({ code: 'TIME_PAST' }, () => "This timeslot isn't available anymore.")
    .with({ code: 'INVALID_HEAD_COUNT' }, () => 'Enter a valid amount')
    .with({ code: 'PAST_THRESHOLD' }, () => 'This vendor requires a greater lead time in order to fulfil an order of this size.')
    .with({ code: 'TOO_LOW' }, () => 'This vendor cannot fulfil an order of this size.')
    .with({ code: 'TOO_HIGH' }, () => 'This vendor cannot fulfil an order of this size.')
    .with({ code: 'INVALID_BASKET_ITEMS' }, () => 'Some items have been updated or deleted by the vendor.')
    .with({ code: 'NO_PAYMENT_METHOD' }, () => 'Please select a payment method')
    .with({ code: 'NO_BILLING_ADDRESS' }, () => 'Please enter a billing address')
    .with({ code: 'NO_BILLING_ADDRESS_LABEL' }, () => 'Please enter a billing address label')
    .with({ code: 'NO_BILLING_ADDRESS_STREET' }, () => 'Please enter a billing address street')
    .with({ code: 'NO_BILLING_ADDRESS_POSTCODE' }, () => 'Please enter a billing address postcode')
    .with({ code: 'NO_BILLING_ADDRESS_CITY' }, () => 'Please enter a billing address city')
    .with({ code: 'NO_BILLING_ADDRESS_COUNTRY' }, () => 'Please enter a billing address country')
    .exhaustive();
exports.validationErrorToUserFriendlyMessage = validationErrorToUserFriendlyMessage;
